export const microCleanlinesTemplateD = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_authorised' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  {
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.general.ippn' },
  { header: 'generateReport.dataToResult.report.general.posicao_amostra' },
  { header: 'generateReport.dataToResult.report.general.id_amostra' },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_05_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_05_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_10_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_10_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_15_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_15_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_20_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_20_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_25_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_25_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_30_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_30_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_35_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_35_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_40_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_40_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_45_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_45_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_50_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_a_50_grossa',
  },

  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_05_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_05_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_10_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_10_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_15_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_15_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_20_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_20_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_25_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_25_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_30_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_30_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_35_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_35_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_40_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_40_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_45_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_45_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_50_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_b_50_grossa',
  },

  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_05_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_05_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_10_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_10_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_15_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_15_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_20_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_20_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_25_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_25_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_30_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_30_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_35_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_35_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_40_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_40_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_45_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_45_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_50_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_c_50_grossa',
  },

  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_05_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_05_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_10_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_10_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_15_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_15_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_20_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_20_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_25_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_25_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_30_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_30_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_35_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_35_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_40_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_40_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_45_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_45_grossa',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_50_fina',
  },
  {
    header:
      'generateReport.dataToResult.report.test.cleanlinessD.tipo_d_50_grossa',
  },
]
